import React from 'react'

import './hero.css'
import { HeroSocial } from './HeroSocial'
import { CTA } from './CTA'


export const Hero = () => {

  return (
      <section id="hero" className="hero_section show_animate">
        <div className="container hero_container">
            <HeroSocial />
            <div className="bubble">
              <span className='animate' style={{'--i':"2"}}></span>
            </div>
            <div className="introduction">
                <h1 className="hello">I'm <span className="first_initial">Paul Black</span>
                  <span className='animate' style={{'--i':"3"}}></span>
                </h1>
                <h2 className="developer">{"Web Developer"}
                  <span className='animate' style={{'--i':"4"}}></span>
                </h2>
                <h4>I like learning new technologies and developing products for the web.
                <span className='animate' style={{'--i':"5"}}></span>
                </h4>
                <CTA/>
            </div>
        </div>
      </section>
  )
}
